import { inject, Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, shareReplay } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProgressBarService {
  private zone = inject(NgZone);

  protected readonly progressBarSubject = new BehaviorSubject<boolean>(false);
  protected readonly loadingMap: Map<string, boolean> = new Map();

  public getProgressBar$() {
    return this.progressBarSubject.asObservable().pipe(shareReplay(1));
  }

  public setLoading(loading: boolean, url: string): void {
    if (!url) {
      throw new Error('The request URL must be provided');
    }

    this.zone.run(() => {
      if (loading) {
        this.loadingMap.set(url, true);
        this.progressBarSubject.next(true);
      } else {
        this.loadingMap.delete(url);
        if (this.loadingMap.size === 0) {
          this.progressBarSubject.next(false);
        }
      }
    });
  }
}
